/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeNoteStatusCommand } from '../../models/change-note-status-command';
import { ChangeNoteStatusCommandResult } from '../../models/change-note-status-command-result';

export interface ApiKpiReportsChangeNoteStatusPost$Plain$Params {
      body?: ChangeNoteStatusCommand
}

export function apiKpiReportsChangeNoteStatusPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpiReportsChangeNoteStatusPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeNoteStatusCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsChangeNoteStatusPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangeNoteStatusCommandResult>;
    })
  );
}

apiKpiReportsChangeNoteStatusPost$Plain.PATH = '/api/KPIReports/ChangeNoteStatus';
